module.exports = __webpack_public_path__ + "static/media/puffy.326f106f.png";